// Default messages
export const MESSAGES = {
  GENERAL_ERROR: 'Internal Server Error',
  VIEW_PROOF_ERROR: 'Unable to download the proof. Please try again.',
  NO_ROWS_TEXT: 'No results found',
  NO_ORDER_DETAILS_CONTACTS_TEXT: 'No results meet your current search',
  NO_RESULTS_TEXT: 'No results meet your current ',
  NO_RESULTS_SEARCH_TEXT: 'No results meet your current search',
  NO_RESULTS_FILTERS_TEXT: 'No results meet your current filters',
  SEARCH_PLACE_HOLDER_MOBILE: 'Search here...',
  HIRE_DESIGNER: {
    TITLE: 'Custom Design Form',
    SUBMIT_BUTTON: 'Next',
    INVALID_URL: 'Please enter a valid URL.',
    CHARGE_DIALOG: {
      TITLE: 'Charge',
      Typography_START: "You'll be charged",
      Typography_END: 'for this design.',
      PURCHASE_BUTTON: 'Purchase Now',
      PURCHASE_FAILED: 'Purchase failed due to low wallet balance',
    },
    PURCHASE_DIALOG: {
      TITLE: 'Purchase Successfully',
      TYPOGRAPHY:
        'Thank you for your purchase! You will receive your proof via email from within two business days. Your proof edits can be submitted via email once the first proof has been received.',
      OK_BUTTON: 'OK',
    },
  },
  AUTH: {
    INVALID_EMAIL: 'Invalid email address',
    EMAIL_REQUIRED: 'Email is required',
    INVALID_PASSWORD: `Must be at least 8 characters long and include at least 1 uppercase and lowercase letter, number, and symbol.`,
    INVALID_PHONE: 'Invalid phone number',
    PASSWORD_UPDATED_HEADING: 'Password Reset',
    PASSWORD_UPDATED: 'Your Password has been Successfully Reset!',
    PASSWORD_MATCH_ERROR: 'Passwords must match',
    PASSWORD_REQUIRED: 'Password is required',
    RESET_CODE: 'A new code has been sent to ',
    NEWS_LETTER_TEXT:
      'I would like to receive product updates and promotional emails from Open Letter Connect',
    LAST_NAME_REQUIRED: 'Last Name is required',
    FIRST_NAME_REQUIRED: 'First Name is required',
    INDUSTRY_REQUIRED: 'This field is required',
    COMPANY_REQUIRED: 'This field is required',
    CRM_REQUIRED: 'This field is required',
    ROLE_REQUIRED: 'This field is required',
    ABOUT_REQUIRED: 'This field is required',
  },
  SIGN_IN: {
    TITLE: 'Sign in to Your Account',
    DESCRIPTION: 'Enter your details to access your OLC account.',
    INPUT_LABEL_EMAIL: 'Email',
    EMAIL_PLACEHOLDER: 'Email Address',
    INPUT_LABEL_PASSWORD: 'Password',
    FORGOT_BUTTON: 'Forgot Password?',
    SIGN_UP_TEXT: `Don't have an Account? `,
    SIGN_UP_BUTTON: 'Sign Up',
    SUBMIT_BUTTON: 'Sign In',
    INVALID_EMAIL_OR_PASSWORD: 'Invalid Email or Password!',
  },
  SIGN_UP: {
    TITLE: 'Create Your Account',
    INPUT_LABEL_FIRST_NAME: 'First Name',
    INPUT_LABEL_LAST_NAME: 'Last Name',
    INPUT_LABEL_INDUSTRY: 'What industry are you part of?',
    INDUSTRY_PLACEHOLDER: 'Finance',
    INPUT_LABEL_COMPANY: 'How large is your company?',
    COMPANY_PLACEHOLDER: '1-5',
    INPUT_LABEL_CRM: 'What CRM do you use?',
    INPUT_LABEL_ROLE: 'What is your role?',
    ROLE_PLACEHOLDER: 'Business Owner',
    INPUT_LABEL_ABOUT: 'How did you hear about us?',
    ABOUT_PLACEHOLDER: 'Facebook',
    INPUT_LABEL_PHONE: 'Phone Number',
    PHONE_PLACEHOLDER: 'Enter your phone number',
    PHONE_REQUIRED: 'Phone number is required',
    PHONE_MAX_LENGTH: 'Phone number cannot exceed 20 digits',
    INPUT_LABEL_EMAIL: 'Email',
    EMAIL_PLACEHOLDER: 'Email Address',
    INPUT_LABEL_PASSWORD: 'Password',
    INPUT_LABEL_CONFIRM_PASSWORD: 'Confirm Password',
    AGREE_TEXT: 'I agree to all ',
    TERMS_TEXT: 'Terms & Conditions',
    SIGN_IN_TEXT: `Already have an Account? `,
    SIGN_IN_BUTTON: 'Sign In',
    JOIN_BUTTON: 'Join Your Team',
    SUBMIT_BUTTON: 'Sign Up',
    NEW_TEXT: {
      GET_STARTED_TEXT: "Let's Get Started",
      COMPLETE_FORM_TEXT: 'Complete the form to create your OLC account.',
      COMPLETE_ACCOUNT_SETUP: 'Complete your account',
      INVELO_ACCOUNT: 'Complete the form to create your Invelo account.',
      BEST_FIT_TEXT: 'Getting started with OLC',
      BEST_FIT_DESCRIPTION: 'Complete the form to create your account.',
      INPUT_LABEL_FIRST_NAME: 'First name',
      INPUT_PLACEHOLDER_FIRST_NAME: 'Enter your first name',
      INPUT_LABEL_LAST_NAME: 'Last name',
      INPUT_PLACEHOLDER_LAST_NAME: 'Enter your last name',
      INPUT_LABEL_EMAIL_NEW: 'Your Email',
      EMAIL_PLACEHOLDER_NEW: 'Enter your email',
      INPUT_LABEL_COMPANY_NEW: 'Company name',
      COMPANY_PLACEHOLDER_NEW: 'Enter your company name',
      INPUT_LABEL_PHONE_NO_NEW: 'Phone number',
      PHONE_NO_PLACEHOLDER_NEW: 'Enter your phone number',
      INPUT_LABEL_PASSWORD_NEW: 'Create your password',
      INPUT_LABEL_PASSWORD_REQUIRED: 'Enter your password',
      SIGN_UP_WITH_EMAIL_TEXT: 'or sign up with',
      SUBMIT_BUTTON_NEW: 'Try for free',
      GOOGLE_TEXT: 'Google',
      LOGIN_TEXT: 'Login',
      AGREE_TEXT_NEW_PART1: 'I agree to the ',
      TERMS: 'Terms of Service',
      AGREE_TEXT_NEW_PART2: ' and ',
      PRIVACY_POLICY: 'Privacy Policy',
      EMAILS_AND_PRODUCT_UPDATES:
        'I agree to receive marketing emails and product updates from OLC',
      INDUSTRY_QUESTION: 'Which industry best describes your business?',
      DIRECT_MAIL: 'Are you currently using direct mail?',
      ANNUAL_REVENUE: 'What is your monthly marketing spend?',
      LETS_GO: "Let's Go",
    },
  },
  RESET_PASSWORD: {
    TITLE: 'Reset Password',
    INPUT_LABEL_PASSWORD: 'Password',
    INPUT_LABEL_CONFIRM_PASSWORD: 'Confirm Password',
    SUBMIT_BUTTON: 'Reset Password',
  },
  VERIFICATION: {
    TITLE: 'Verification',
    HEADING: 'Please enter the verification code sent to you via email.',
    INPUT_LABEL_CODE: 'Verification Code',
    SUBMIT_BUTTON: 'Verify',
    RESEND_BUTTON: 'Resend Code',
  },
  FORGOT_PASSWORD: {
    TITLE: 'Forgot Password?',
    HEADING: 'Please enter your email and a verification code will be sent to you.',
    INPUT_LABEL_EMAIL: 'Email',
    EMAIL_PLACEHOLDER: 'Enter Email Address',
    SUBMIT_BUTTON: 'Send Email',
  },
  MODE: {
    TEST_LABEL: 'Test',
    LIVE_LABEL: 'Live',
    LIVE_MODE_ONLY_FEATURE: 'This feature is only available in Live Mode.',
    MODAL: {
      TEST_MODE_MESSAGE: 'Are you sure you want to enter Test Mode?',
      TEST_MODE_DESCRIPTION:
        'Test Mode is for practice only. No real mail is sent. Templates carry over to Live Mode, but all other items stay in Test Mode.',
    },
  },
  UNVERIFIED_EMAIL: {
    TITLE: 'Verify Your Email',
    HEADING: 'Please Verify your email to access Open Letter Connect.',
    RESEND_BTN_TEXT: 'Resend Verification',
  },
  CUSTOMIZE_COLUMNS: {
    BUTTON: 'Customize Columns',
    TITLE: 'Customize Columns',
    MIN_COLUMNS_NOTE: (count) =>
      `Choose the columns to show. At least ${count} must stay selected.`,
    RESET: 'Reset to default',
    CANCEL: 'Cancel',
    SAVE: 'Save',
  },
  CONTACTS: {
    REMOVE_DNC_HEADER: 'Remove DNC',
    REMOVE_DNC_MESSAGE: 'Are you sure you want to remove DNC from selected contacts?',
    REMOVE_DNC_BUTTON: 'Yes',
    ACTIONS_BTN_TEXT: 'Actions',
    IS_DNC_LIST: 'Do Not Contact',
    IS_DNC_IMPORT_NOTE: 'This contact list will be excluded from the mailing(s).',
    EXPORT_CONTACTS: 'Are you sure you want to export these Contacts?',
    EXPORT_SINGLE_CONTACTS: 'Are you sure you want to export this Contact?',
    DETAILS_EXPORT_SINGLE_CONTACT_DESCRIPTION:
      "You'll receive a confirmation email when the export is completed.",
    DELETE_CONTACTS: 'Are you sure you want to delete these Contacts?',
    DELETE_SINGLE_CONTACTS: 'Are you sure you want to delete this Contact?',
    SEARCH_PLACE_HOLDER: 'Search by name, company, address, phone, or email',
    END_DATE_REQUIRED: 'Please select the end date.',
    FILTERS_REQUIRED: 'Please select any filters.',
    SINGLE_EXPORT_HEADER: 'Export',
    SINGLE_EXPORT_HEADER_NEW: 'Export Contact',
    MULTI_EXPORT_HEADER: 'Export list',
    MULTI_EXPORT_HEADER_NEW: 'Export Contacts',
    EXPORT_BUTTON_TEXT: 'Export',
    SINGLE_DELETE_HEADER: 'Delete',
    SINGLE_CONTACT_DELETE_HEADER: 'Delete Contacts',
    MULTI_DELETE_HEADER: 'Delete list',
    MULTI_DELETE_HEADER_NEW: 'Delete Contacts',
    SINGLE_DELETE_HEADER_NEW: 'Delete Contact',
    DELETE_MESSAGE_NEW:
      'These contacts will be deleted from your Contacts database but will still be included in associated orders.',
    CLEAR_FILTER_BTN_TEXT: 'Clear Filters',
    CREATE_BTN_TEXT: 'Create',
    CONTACT_ACTIONS: 'Contact Actions',
    DELETE_CONTACT: 'Delete Contact',
    ACTIONS: {
      EXPORT_CONTACTS: 'Export Contacts',
      DELETE_CONTACTS: 'Delete Contacts',
      ADD_TAGS: 'Add Tag(s)',
      REMOVE_TAGS: 'Remove Tag(s)',
      REMOVE_DNC: 'Remove DNC',
      PLACE_ORDER: 'Place Order',
    },
    EXPORT_BTN_TEXT: 'Export',
    TAGS_ADD_PLACEHOLDER: 'Type to create a tag. Use a comma to separate tags.',
    TAGS_REMOVE_PLACEHOLDER: 'Select Tags',
    TAGS_UPDATE_TEXT: 'Add Tags',
    TAGS_REMOVE_TEXT: 'Remove Tags',
    TAGS_UPDATE_BTN_TEXT: 'Cancel',

    TAGS_REMOVE_NOTE_TEXT: 'Are you sure you want to remove tags for selected contacts?',
    TAGS_UPDATE_ERROR: 'Please select at least one tag.',
    TAGS_UPDATE_SUCCESS_MESSAGE: 'Your request is in progress and will be completed shortly.',
    IMPORT_BTN_TEXT: 'Import',
    DELETE_BTN_TEXT: 'Delete',
    EDIT_BTN_TEXT: 'Edit',
    SAVE_BTN_TEXT: 'Save',
    EXPORT_MESSAGE: `You'll receive a confirmation email when the export is completed.`,
    DELETE_MESSAGE: `You'll receive a confirmation email when the delete is completed.`,
    CONTACT_DETAIL_TITLE: 'Contact Details',
    CONTACT_BACK_ARROW: 'Contacts',
    SELECT_ALL_ITEMS: 'Select All',
    SELECT_VISIBLE_ITEMS: 'Select Visible',
    SELECT_NONE: 'Select None',
    MAILING_ADDRESS_TOOLTIP: 'The address where this contact receives mail.',
    PROPERTY_ADDRESS_TOOLTIP: 'The physical location of the property associated with this contact.',
    PROPERTY_TAB: {
      PROPERTY_TAB_TITLE: 'Connect Owners to Their Properties',
      PROPERTY_TAB_DESCRIPTION:
        'Link a homeowner to the property they own, even if they don’t live there. Ideal for targeting property owners instead of renters.',
      ENABLE_PROPERTY_ADDRESS: 'Enable Property Address Linking',
    },
    CUSTOM_FIELDS_TAB: {
      CUSTOM_FIELDS_TAB_TITLE: 'No Custom Fields',
      CUSTOM_FIELDS_TAB_DESCRIPTION:
        'Custom fields let you capture extra details on your records. Add your first custom field to stay better organized.',
      ENABLE_CUSTOM_FIELDS: 'Add a Custom Field',
    },
    RETURN_ADDRESS_TOOLTIP:
      'Allows this contact’s details to be used as the return address when placing orders.',
    DO_NOT_CONTACT_TOOLTIP: 'Excludes this contact from all future mailings.',
    EVENTS_LOGS: {
      TITLE: 'Event Logs',
      NO_EVENT_LOGS: 'No Event Logs Available',
      DUMMY_DATA: {
        ADDRESS_1_LABEL: '605 Abdul Haque Rd, Block H-3 Block H 3 Phase 2.',
        EVENT_1: ' Created',
        DATE_1: 'Nov 15, 2023 06:39:39 AM',
        ADDRESS_2_LABEL: '605 Abdul Haque Rd, Block H-3 Block H 3 Phase 2.',
        EVENT_2: ' Updated',
        DATE_2: 'Nov 15, 2023 09:39:39 AM',
      },
    },
    NO_CONTACTS_SCREEN: {
      TITLE: 'No Contacts Created Yet',
      DESC: 'Store and manage the people or businesses you want to reach. Contacts include mailing addresses, property details, and other information used to build lists and run campaigns.',
      CREATE_CONTACT_BUTTON: 'Create New Contact',
      IMPORT_BTN_TEXT: 'Import Contacts',
    },
    ADVANCE_FILTERS: {
      HEADING: 'Filters',
      SEARCH_TAG: 'Select Tag',
      CREATE_TAG: 'Select or create a Tag',
      TAG_SEARCH_PLACEHOLDER: 'Search a Tag',
      TAG_SEARCH_PLACEHOLDER_NEW: 'Tags',
      NO_SEARCH_TAG: 'No Tags to show',
      ADDRESS_STATUS: 'Address Status',
      NO_ADDRESS_STATUS: 'No Address Status to show',
      MAILED_STATUS: 'Last Mailed Status',
      CONTACT_TYPE: 'Contact Type',
      NO_CONTACT_TYPE: 'No Contact Type to show',
      NO_MAILED_STATUS: 'No Last Mailed Status to show',
      MAILED_DATE: 'Last Mailed Date',
      NO_TAGS_CONTACTS: 'No Tags Assigned',
      CREATED_DATE: 'Created Date',
      QR_SCAN_DATE: 'Last QR Code Scan Date',
      MAILING_ACTIVITY: 'Mailing Activity',
      ACTIVE_MAILING: 'Show active mailings',
      TAGS_LABEL: 'Tags',
      CANCEL_BUTTON: 'Clear',
      SUBMIT_BUTTON: 'Apply',
    },
    DELETE: {
      TITLE: 'Delete Contact',
      HEADING: 'Are you sure you want to delete this contact?',
      MESSAGE:
        'Are you sure you want to delete this contact? This contact will be deleted from your Contacts database but will still be included in associated orders.',
      CANCEL_BUTTON: 'No',
      SUBMIT_BUTTON: 'Yes',
      ADD_BUTTON: 'Add',
      REMOVE_BUTTON: 'Remove',
    },
    IMPORT: {
      TITLE: 'Import Contacts',
      OFFER_PERCENTAGE: 'Choose an Offer Percentage',
      OFFER_PERCENTAGE_DESCRIPTION: 'Upload a list to generate the first 5 offer values',
      OFFER_PERCENTAGE_TABLE: {
        TITLE: 'Find Your Offer Percentage',
        OFFER_LEVEL: 'Offer Level',
        OFFER_1: 'Offer 1 (50%)',
        OFFER_2: 'Offer 2 (79%)',
        OFFER_3: 'Offer 3 (83%)',
        OFFER_4: 'Offer 4 (90%)',
        CUSTOM: 'Custom',
        SUBMIT_BUTTON: 'Choose Offer',
        NO_DATA_FOUND: 'no data found',
      },
      UPLOAD_FILE: {
        TITLE: 'Upload a File',
        DRAG_TEXT: ' or drag and drop',
        FILE_TYPE: 'CSV Files only',
        REQUIRED: '*File upload is required',
        REPLACE: 'Please remove the current file to add new one',
        EMPTY_FILE: 'Empty file is not allowed, please upload another one',
        INVALID_FILE: 'Error: Unsupported file format.',
      },
      DOWNLOAD: 'Download',
      SAMPLE_FILE: ' our sample CSV file here.',
      SMARTY_VALIDATIONS: {
        REQUIRED: '*',
        VALID_CONTACTS: ' Contacts will be imported',
        VALID_CONTACT: ' Contact will be imported',
        MISSING_CONTACT: ' contact will be skipped due to missing information',
        MISSING_CONTACTS: ' contacts will be skipped due to missing information',
        DUPLICATES_CONTACT: ' contact will be skipped due to duplicates',
        DUPLICATES_CONTACTS: ' contacts will be skipped due to duplicates',
        INVALID_CUSTOM_FIELD_CONTACT:
          ' contact had custom field values dropped due to validation errors',
        INVALID_CUSTOM_FIELD_CONTACTS:
          ' contacts had custom field values dropped due to validation errors',
        PROCESSED_RESULT: 'Processed Result',
        PROCESSED_RESULT_DOWNLOAD_TEXT:
          'Download the processed result CSV to review skipped rows and custom field validation errors.',
        PROCESSED_RESULT_EMAIL_TEXT:
          'You will be emailed a CSV of the skipped records once list is imported.',
      },
      ACTIONS: {
        SUCCESS_TITLE: 'Contacts are Importing',
        SUCCESS_MESSAGE: ' Contact will be imported',
        SUCCESS_MESSAGE_MULTIPLE: ' Contacts will be imported',
        SUCCESS_DESCRIPTION:
          'You will receive an email when your contact has been imported into your database.',
        SUCCESS_DESCRIPTION_MULTIPLE:
          'You will receive an email when your contacts have been imported into your database.',
        CANCEL_DESCRIPTION: 'You will lose your changes after canceling.',
        CANCEL_TITLE: 'Confirm Cancel Import',
        CANCEL_MESSAGE: 'Are you sure you want to cancel this Import?',
        DONE_TEXT: 'OK',
        BACK_TEXT: 'Go Back',
        CANCEL_TEXT: 'Cancel Import',
      },
      CONTACTS_MAPPING: {
        TITLE: 'Map your CSV file',
        MATCH_LABEL: 'Match',
        OUR_LABEL: 'Our Fields',
        OLC_LABEL: 'OLC Fields',
        CSV_LABEL: 'CSV Columns',
        SAMPLE_LABEL: 'Sample Data',
        REQUIRED: '*',
        REQUIRED_TEXT: ' is required',
        SUBMIT_BUTTON: 'Process CSV',
        CANCEL_BUTTON: 'Cancel',
        CLOSE_BUTTON: 'Close',
      },
      CANCEL_BUTTON: 'Cancel',
      SUBMIT_BUTTON: 'Import',
      CONTINUE: 'Continue',
    },
    CREATE: {
      TITLE: 'Create Contact',
      FIRST_NAME_LABEL: 'First Name*',
      FIRST_NAME_LABEL_PLACEHOLDER: 'Enter First Name',
      LAST_NAME_LABEL: 'Last Name',
      LAST_NAME_LABEL_PLACEHOLDER: 'Enter Last Name',
      COMPANY_LABEL: 'Company',
      COMPANY_LABEL_NEW: 'Company Name*',
      COMPANY_LABEL_PLACEHOLDER: 'Enter Company Name',
      NEW_COMPANY_LABEL: 'Company Name',
      ADDRESS_1_LABEL: 'Mailing Address 1*',
      NEW_ADDRESS_1_LABEL: 'Mailing Address 1',
      ADDRESS_2_LABEL: 'Mailing Address 2',
      NEW_ADDRESS_2_LABEL: 'Mailing Address 2',
      PHONE_VALIDATION: 'Phone number is not valid',
      CITY_LABEL: 'Mailing City*',
      NEW_CITY_LABEL: 'Mailing City',
      STATE_LABEL: 'Mailing State*',
      NEW_STATE_LABEL: 'Mailing State',
      ZIP_LABEL: 'Mailing Zip Code*',
      NEW_ZIP_LABEL: 'Mailing Zip Code',
      PHONE_LABEL: 'Contact Phone Number',
      PHONE_LABEL_PLACEHOLDER: 'Enter Phone Number',
      EMAIL_LABEL: 'Contact Email',
      EMAIL_LABEL_PLACEHOLDER: 'Enter Email Address',
      TAGS_LABEL: 'Tags',
      TAGS_PLACEHOLDER: 'Search a Tag',
      CREATE_SEARCH_TAGS_PLACEHOLDER: 'Search or Create a Tag',
      CREATE_SEARCH_TAGS_PLACEHOLDER_IMPORT: 'or Create a Tag',
      CREATE_SEARCH_TAGS_PLACEHOLDER_NEW: 'Select Tags',
      FIRST_NAME_OR_COMPANY_REQUIRED: 'The first name or company name field is required',
      COMPANY_MAX_LENGTH: 'Company name must be less than 100 characters',
      ADDRESS_1__REQUIRED: 'Mailing Address 1 is required',
      CITY_REQUIRED: 'Mailing City is required',
      STATE_REQUIRED: 'Mailing State is required',
      ZIP_REQUIRED: 'Mailing Zip Code is required',
      SUBMIT_BUTTON: 'Create',
      CANCEL_BUTTON: 'Cancel',
      PROPERTY_ADDRESS: 'Property Address',
      PROPERTY_CITY: 'Property City',
      PROPERTY_STATE: 'Property State',
      PROPERTY_ZIP: 'Property Zip Code',
      PROPERTY_OFFER: 'Property Offer',
      RETURN_ADDRESS_LABEL: 'Use as Return Address',
      CONTACT_HEADER: 'Contact Information',
      PROPERTY_HEADER: 'Property Address',
      MAILING_HEADER: 'Mailing Address',
    },
    EDIT: {
      FIRST_NAME_OR_COMPANY: 'The first name or company name field is required',
      FIRST_NAME_LABEL: 'First Name',
      LAST_NAME_LABEL: 'Last Name',
      COMPANY_LABEL: 'Company',
      COMPANY_MAX_LENGTH: 'Company name must be less than 100 characters',
      ADDRESS_1_LABEL: 'Mailing Address 1',
      ADDRESS_2_LABEL: 'Mailing Address 2',
      CITY_LABEL: 'Mailing City',
      STATE_LABEL: 'Mailing State',
      ZIP_LABEL: 'Mailing Zip Code',
      PHONE_LABEL: 'Contact Phone Number',
      TAGS_LABEL: 'Tags',
      EMAIL_LABEL: 'Contact Email',
      ADDRESS_STATUS: 'Address Status',
      TOTAL_MAILED: 'Total Mailed',
      LAST_MAILED_STATUS: 'Last Mailed Status',
      LAST_MAILED_DATE: 'Last Mailed Date',
      DATE_LABEL: 'Date Created',
      USE_AS_RETURN_ADDRESS: 'Use as Return Address',
      IS_DNC_LIST: 'Do Not Contact',
      PROPERTY_ADDRESS: 'Property Address',
      PROPERTY_CITY: 'Property City',
      PROPERTY_STATE: 'Property State',
      PROPERTY_ZIP: 'Property Zip Code',
      PROPERTY_OFFER: 'Property Offer',
    },
  },
  TEMPLATE: {
    SEARCH_PLACE_HOLDER: 'Search by template name or template ID',
    NAME_REQUIRED: 'Template Name is required',
    TYPE_REQUIRED: 'Template Type is required',
    DUPLICATE_TEMPLATE_REQUIRED: 'Please save the template before duplicating the existing one.',
    NAME_LESS_50: 'Template Name should be less than or equal to 50 characters',
    NO_TEMPLATE_TITLE: 'No Templates Yet',
    NO_TEMPLATE_MESSAGE:
      'Templates are reusable direct mail designs. Build from scratch, choose from hundreds of prebuilt options, or work with a marketing designer to create one for you.',
    NO_TEMPLATE_HIRE_DESIGNER_BUTTON: 'Hire a Designer',
    NO_TEMPLATE_BUTTON: 'Create Template',
    CREATE_OPTIONS_TITLE: 'Create New Template',
    CREATE_OPTIONS_CREATE_TEMPLATE: 'Create Template',
    CREATE_OPTIONS_HIRE_DESIGNER: 'Hire a Designer',
    LIMIT_MODAL: {
      TITLE: 'Feature Not Available',
      HEADING: 'This feature is not included in your current plan.',
      SUB_HEADING: 'Upgrade your plan to access this functionality.',
      CANCEL_BUTTON: 'Cancel',
      SUBMIT_BUTTON: 'View Plans',
    },
    DELETE: {
      TITLE: 'Delete Template',
      HEADING: 'Are you sure you want to delete this Template?',
      PARAGRAPH:
        'This template will be deleted from your Templates list but will still be included in associated orders.',
    },
    SAVE: {
      TITLE: 'Confirm Save Template',
      HEADING: 'Are you sure you want to save this template?',
      PARAGRAPH:
        'The updates provided will be used right away for any orders referencing this template.',
    },
    CANCEL: {
      TITLE: 'Confirm Cancel Template',
      HEADING: 'Are you sure you want to cancel this Template?',
      PARAGRAPH: 'You will lose your changes after canceling.',
    },
    TEMPLATE_BUILDER: {
      CREATED: 'Template Created Successfully',
      UPDATED: 'Template Updated Successfully',
    },
    CLONE_TEMPLATE: {
      TITLE: 'Template Cloned Successfully',
      HEADING:
        'Do you want to stay on the current template, or open the newly cloned template in the builder?',
      CANCEL_BUTTON: 'Stay Here',
      SUBMIT_BUTTON: 'Open Clone',
    },
  },
  ORDERS: {
    SEARCH_PLACE_HOLDER: 'Search by order name or order ID',
    CLEAR_FILTER_BTN_TEXT: 'Clear Filters',
    CANCEL_ORDER_BTN_TEXT: 'Cancel Order',
    EXPORT_BTN_TEXT: 'Export',
    PAY_AND_PROCESS_BTN_TEXT: 'Pay and Process',
    END_DATE_REQUIRED: 'Please select the end date.',
    FILTERS_REQUIRED: 'Please select any filters.',
    ORDER_NAME_TOOLTIP: 'Order Name:',
    NO_ORDERS_SCREEN: {
      TITLE: 'You have no Orders in your database',
      TITLE_NEW: 'No Orders Yet',
      DESCRIPTION:
        'Send mail and track it all—status, history, and results. Create your first order to start mailing and measuring performance.',
      CREATE_ORDER_BUTTON: 'Create Order',
    },
    ADVANCE_FILTERS: {
      HEADING: 'Filters',
      CREATED_BY_LABEL: 'Created By',
      CREATED_BY_PLACEHOLDER: 'Search by user name/email',
      NO_CREATED_BY: 'No Created By to show',
      PRODUCT_TYPE_LABEL: 'Product type',
      PRODUCT_TYPE_LABEL_NEW: 'Product',
      NO_PRODUCT_TYPE: 'No Product to show',
      SOURCE_LABEL: 'Source',
      ADDRESS_LABEL: 'Mailing Name or Address',
      PROPERTY_ADDRESS: 'Property Address',
      ADDRESS_PLACEHOLDER: 'Mailing Name or Address',
      CAMPAIGN: 'Campaign',
      CAMPAIGN_PLACEHOLDER: 'Search Campaign',
      NO_SOURCE: 'No Source to show',
      ORDER_STATUS_LABEL: 'Order Status',
      NO_ORDER_STATUS: 'No Order Status to show',
      PAYMENT_STATUS_LABEL: 'Payment Status',
      NO_PAYMENT_STATUS: 'No Payment Status to show',
      TEMPLATE_LABEL: 'Template',
      NO_TEMPLATE: 'No Template to show',
      CREATED_DATE_LABEL: 'Created Date',
      SCHEDULED_DATE_LABEL: 'Scheduled Date',
      MAILING_DATE_LABEL: 'Mailing Date',
      MAILED_DATE_LABEL: 'Mailed Date',
      CANCEL_BUTTON: 'Clear',
      SUBMIT_BUTTON: 'Apply',
    },
    CREATE: {
      TITLE: 'Create New Order',
      DELIVERABLES_REQUIRED:
        'You should have at least 1 deliverable contact before submitting the order.',
      PROOF_REQUIREMENT:
        'You should have at least 1 deliverable contact before downloading the proof',
      PAYMENT_METHOD_REQUIRED: {
        TITLE: 'Add a credit card to place your order',
        CLOSE_BUTTON: 'Close',
        SUBMIT_BUTTON: 'Confirm Order',
      },
      ACH_PAYMENT_HEADING: 'Payment via ACH',
      ACH_FUNDS_CONFIRMATION:
        'This customer pays via ACH. I confirm that funds have been (or will be) added to their wallet.',
      INSUFFICIENT_FUNDS_WARNING: {
        TITLE: 'Insufficient wallet balance',
        BODY: "This customer's wallet balance is lower than the estimated cost of this order. Please add funds to their wallet so the order can be charged.",
        BALANCE_LABEL: 'Wallet balance',
        COST_LABEL: 'Estimated order cost',
        CONFIRM_BUTTON: 'Place Order Anyway',
        CANCEL_BUTTON: 'Go Back',
      },
      TEMPLATE_LABEL: 'Select Template',
      ORDER_TYPE_REQUIRED: 'Order type is required',
      TEMPLATE_REQUIRED: 'Template is required',
      CAMPAIGN_REQUIRED: 'Campaign is required',
      PRODUCT_TYPE_LABEL: 'Product Type: ',
      ENVELOPE_TYPE_LABEL: 'Envelope Type: ',
      POSTCARD_SIZE_LABEL: 'Postcard Size: ',
      POSTAGE_TYPE_LABEL: 'Postage Type',
      DESIGN_FORMAT_LABEL: 'Design Format',
      OFFER_PERCENTAGE_LABEL: 'Enter Offer Percentage*',
      OFFER_PERCENTAGE_DESCRIPTION: 'Unsure of your offer percentage?',
      OFFER_PERCENTAGE_LINK: 'Click here',
      OFFER_PERCENTAGE_PLACEHOLDER: 'Type in a Number between 0-100',
      OFFER_PERCENTAGE_REQUIRED: 'Valid Offer Percentage is required',
      MAX_RECORDS: 5,
      POSTAGE_TYPE_REQUIRED: 'Postage Type is required',
      ENVELOPE_STYLE_LABEL: 'Envelope Style ',
      ENVELOPE_TYPE_LABEL: 'Envelope Type ',
      ENVELOPE_STYLE_REQUIRED: 'Envelope Style is  required',
      MAILER_PROOF_LABEL: 'Download Mailer Proof',
      ENVELOPE_PROOF_LABEL: 'Download Envelope Proof',
      HTML_TEMPLATE_LABEL: '*HTML Templates cannot display an image. Click to Download proof.',
      CONTACT_COUNT_TEXT: ' Contact Selected ',
      CONTACTS_COUNT_TEXT: ' Contacts Selected ',
      CONTACT_REQUIRED: 'Contact is required',
      RETURN_ADDRESS_TITLE: 'Return Address*',
      RETURN_ADDRESS_TITLE_NEW: 'Return Address',
      RETURN_ADDRESS_REQUIRED: 'This field is required',
      DATE_LABEL: 'Scheduled Date* ',
      DATE_LABEL_NEW: 'Scheduled Date',
      DATE_LABEL_NEW2: 'Mail Date',
      DATE_REQUIRED: 'This field is required',
      DELIVERY_DATE: 'Mail Date: ',
      ORDER_NAME: 'Order Name (Optional)',
      BATCHING_NOT_ALLOWED:
        'Batching is not available on your current plan. Upgrade your plan to access this feature.',
      BATCHING_NOT_ALLOWED_HEADER: 'Plan Limitation',
      FIND_NEW_CONTACTS_ESTIMATE_ERROR: 'We could not complete the request. Please try again.',
      CANCEL_BUTTON: 'Cancel',
      NEXT_BUTTON: 'Next',
      SUBMIT_BUTTON: 'Submit Order',
      LEARN_TITLE: 'Learn More',
      BACK_BUTTON: 'Back',
      CONTACTS: {
        CONTACT_LABEL: 'Select Contacts*',
        SINGLE: 'Single Contact',
        MULTIPLE: 'Multiple Contacts',
        UPLOAD: 'Upload Contacts',
        CREATE: 'Create New Contact',
        SUBMIT_BUTTON: 'Create',
        CANCEL_BUTTON: 'Cancel',
      },
      REVIEW: {
        COST_HEADING: 'Estimated Cost ',
        COST_TITLE:
          'Cost is dependent on merge strictness and the deliverability of your contacts when the order is processed. ',
        HEADING: 'Please review your order carefully before submitting:',
        DELIVERABLE_TITLE: ' deliverable contact',
        DELIVERABLES_TITLE: ' deliverable contacts',
        DOWNLOAD_MAILER_PROOF: 'Download Mailer Proof',
        DOWNLOAD_ENVELOPE_PROOF: 'Download Envelope Proof',
        DOWNLOAD_PROOF: 'Download Mailer Proof',
        DOWNLOAD_PROOF_VALIDATION:
          'Please download the proof before proceeding with order creation.',
        DOWNLOAD_ALL_PROOF_VALIDATION:
          'Please download all the proof(s) before proceeding with order creation.',
        DOWNLOAD_ENVELOPE_VALIDATION:
          'Please download the envelope proof before proceeding with order creation.',
        DOWNLOAD_ALL_ENVELOPE_VALIDATION:
          'Please download all the envelope proof(s) before proceeding with order creation.',
        MAILER_TITLE: ' per mailer',
        PROOF_TITLE: 'Proof is displaying all content correctly',
        SPELLING_TITLE: 'There are no spelling errors',
        VARIABLE_TITLE:
          'All variable fields in my template are correct and merged with correct contact data.',
        REQUIRED: 'All are required',
        HTML_LABEL: 'Download Proof here...',
        PROOF_LABEL: 'Download Proof',
        DESCRIPTION:
          'Orders are charged on their Scheduled Date, not when they are submitted. Orders are eligible to be canceled up to their Scheduled Date.',
      },
      SUBMIT_MODAL: {
        TITLE: 'Order Submitted',
        TITLE_INSUFFICIENT_FUNDS: 'Order Submitted - No Funds',
        CANCEL_TITLE: 'Confirm Cancel Order?',
        HEADING: 'Your Order has been placed Successfully',
        HEADING_INSUFFICIENT_FUNDS:
          'Your order has been placed successfully, however you do not have enough funds in your wallet to cover the order. Please add funds now or enable "automatic funding" to avoid any delay.',
        CANCEL_HEADING: 'Are you sure you want to cancel this Order?',
        DESCRIPTION:
          'You will receive an email when your contacts have been imported into your database.',
        SINGLE_DESCRIPTION:
          'You will receive an email when your contact has been imported into your database.',
        CANCEL_DESCRIPTION: 'You will lose your changes after canceling.',
        BACK_BUTTON: 'Go Back',
        SUBMIT_BUTTON: 'OK',
        CANCEL_BUTTON: 'Cancel Order',
        GO_TO_WALLET: 'Go to Wallet',
        CLOSE: 'Close',
      },
    },
    DETAIL: {
      OVERVIEW: {
        NO_DATA: 'No data',
        NO_DATA_ANALYTICS: 'Analytics are updated when order is in Mailed status',
        MAILED: 'Mailed',
        IN_TRANSIT: 'In Transit',
        DELIVERED: 'Delivered',
        RE_ROUTE: 'Re-Routed',
        RETURNED_TO_SENDER: 'Returned',
        SCANNED: 'Scanned',
        NOT_SCANNED: 'Not Scanned',
        DAY_ELAPSED: 'Days Elapsed Since Mailed',
        CANCEL_ORDER_BUTTON: 'Cancel Order',
        VIEW_PROOF_BUTTON: 'Download Mailer Proof',
        DOWNLOAD_ENVELOPE_PROOF_BUTTON: 'Download Envelope Proof',
        TOTAL_CONTACTS: 'Total Contacts',
        DELIVERABLES: 'Deliverable',
        UNDELIVERABLES: 'Undeliverable',
        DNC: 'Do Not Contact',
        TOTAL_COST: 'Total Cost',
        ADD_FUND_AND_PROCESS_ORDER: 'Add Funds & Process Order',
        PAY_AND_PROCESS_BUTTON: 'Pay & Process Order',
        AMOUNT_NOT_ENOUGH_FOR_ORDER: "*Amount added to your wallet isn't enough for your order",
        TRACKING_DETAILS_TOOLTIP:
          'Tracking updates twice daily. Recent USPS activity may take time to appear.',
        TRACKING_INFO:
          'Tracking shows if a mail piece was mailed, in transit, delivered, rerouted, or returned. Except for Mailed, all updates come from USPS, which may not always provide complete or accurate tracking.',
        SCANNING_INFO:
          'Scanning shows if a mail piece was scanned, not scanned, or the days since mailing. These updates come from USPS, which may not scan every piece or always provide complete or accurate tracking.',
      },
      CONTACTS: {
        FILTER: {
          TITLE: 'Filters',
          FILTER_REQUIRED: 'Please select any filter',
          ADDRESS_STATUS: 'Address Status',
          MAILED_STATUS: 'Mailed Status',
          DELIVERED_DATE: 'Delivered Date',
          CANCEL_BUTTON: 'Clear',
          SUBMIT_BUTTON: 'Apply',
        },
        REMOVE: {
          CONTACT: 'Remove Contact(s)',
          MODAL: {
            REMOVE_CONTACT: {
              SINGLE_REMOVE_HEADING: 'Remove Contact?',
              MULTI_REMOVE_HEADING: 'Remove Contacts?',
              REMOVE_CONTACTS: 'Are you sure you want to remove these Contacts?',
              REMOVE_SINGLE_CONTACTS: 'Are you sure you want to remove this Contact?',
              NOTE: `This action cannot be undone. Please proceed with caution.`,
            },
          },
        },
        TABLE: {
          SELECT_ALL_ITEMS: 'Select All',
          SELECT_VISIBLE_ITEMS: 'Select Visible',
          SELECT_NONE: 'Select None',
          NO_RESULT: 'No results with current filters.',
        },
        CLEAR_FILTERS: 'Clear Filters',
      },
      CAMPAIGN: {
        NO_CAMPAIGNS: 'No Campaigns Details to Show',
      },
      BATCHING: {
        NO_BATCHES: 'No Batching Details to Show',
        ERROR: 'Unable to load batching details. Please try again.',
      },
      MODALS: {
        CANCEL: {
          HEADING: 'Cancel Order?',
          MESSAGE: 'Are you sure you want to cancel this order?',
          MESSAGE_NEW:
            'Are you sure you want to cancel this order? Canceling this order will not incur any charges. This action cannot be undone',
          MULTI_MESSAGE: 'Are you sure you want to cancel this order?',
          SUCCESS_BUTTON: 'Yes',
          SUB_MESSAGE: 'This action cannot be undone. You will not be charged for this order',
          SUB_MESSAGE_NEW:
            'Are you sure you want to cancel this order? Canceling this order will not incur any charges. This action cannot be undone.',
          MULTI_SUB_MESSAGE:
            'If the order placement is currently in progress, the mailing pieces may be affected.',
        },
        PAY_AND_PROCESS: {
          HEADING: 'Process Order',
          HEADING_NEW: 'Pay and Process Order',
          MESSAGE: 'Are you sure you want to proceed?',
          MESSAGE_NEW:
            'Your order will be resubmitted for payment and processing. Once successful, it will be scheduled for ',
          SUCCESS_BUTTON: 'Process Order',
          SUB_MESSAGE:
            'Your order will be resubmitted and processed. The mail date for your order is ',
          MULTI_SUB_MESSAGE: 'Your orders will be resubmitted and processed.',
        },
        EXPORT: {
          HEADING: 'Export Order',
          MESSAGE: 'Are you sure you want to export this order?',
          MULTI_MESSAGE: 'Are you sure you want to export these orders?',
          SUCCESS_BUTTON: 'Yes',
        },
        ADD_FUNDS: {
          HEADING: 'Insufficient Funds',
          MESSAGE: 'Not enough fund in wallet',
          SUCCESS_BUTTON: 'Add Funds',
          SUB_MESSAGE: 'Please add funds before processing this order',
        },
      },
    },
  },
  ACCOUNT: {
    PROFILE: {
      TITLE: 'Profile',
      USER_HEADING: 'User Information',
      FULL_NAME_LABEL: 'Full Name',
      FIRST_NAME_LABEL: 'First Name',
      LAST_NAME_LABEL: 'Last Name',
      EMAIL_LABEL: 'Email',
      PHONE_LABEL: 'Phone Number',
      ACCOUNT_HEADING: 'Account Information',
      COMPANY_LABEL: 'Company: ',
      ADDRESS_1_LABEL: 'Address Line 1: ',
      ADDRESS_2_LABEL: 'Address Line 2: ',
      CITY_LABEL: 'City: ',
      STATE_LABEL: 'State: ',
      ZIP_LABEL: 'Zip Code: ',
      EDIT_BTN_TEXT: 'Edit',
      CHANGE_PASSWORD_BTN_TEXT: 'Change Password',
      EDIT_NAME: {
        TITLE: 'Edit User Information',
        FIRST_NAME_LABEL: 'First Name',
        LAST_NAME_LABEL: 'Last Name',
        LAST_NAME_SPECIAL_CHARS: 'Last Name cannot contain special characters',
        FIRST_NAME_SPECIAL_CHARS: 'First Name cannot contain special characters',
        FIRST_NAME_REQUIRED: 'First Name is required',
        LAST_NAME_REQUIRED: 'Last Name is required',
        FULL_NAME_REQUIRED: 'Full Name is required',
        FIRST_NAME_LIMIT: 'First name must be less than 30 characters',
        LAST_NAME_LIMIT: 'Last name must be less than 30 characters',
        CANCEL_BUTTON: 'Cancel',
        SUBMIT_BUTTON: 'Save',
      },
      EDIT_ACCOUNT_INFO: {
        TITLE: 'Edit Account Information',
        COMPANY_LABEL: 'Company',
        ADDRESS_1_LABEL: 'Address Line 1',
        ADDRESS_2_LABEL: 'Address Line 2',
        CITY_LABEL: 'City',
        STATE_LABEL: 'State',
        ZIP_LABEL: 'Zip Code',
        COMPANY_LIMIT: 'Company name must be less than 100 characters',
        ADDRESS_1_LIMIT: 'Address Line 1 must be less than 100 characters',
        ADDRESS_2_LIMIT: 'Address Line 2 must be less than 100 characters',
        CITY_LIMIT: 'City name must be less than 40 characters',
        STATE_LIMIT: 'State name must be less than 40 characters',
        ZIP_LIMIT: 'Zip Code must be less than 10 characters',
        PHONE_LIMIT: 'Phone number must be less than 20 characters',
        CANCEL_BUTTON: 'Cancel',
        SUBMIT_BUTTON: 'Save',
      },
      CHANGE_PASSWORD: {
        TITLE: 'Change Password',
        OLD_PASSWORD_LABEL: 'Old Password',
        NEW_PASSWORD_LABEL: 'New Password',
        CONFIRM_PASSWORD_LABEL: 'Confirm Password',
      },
      NOTIFICATIONS: {
        TITLE: 'Notifications',
        SUBTITLE:
          'Manage and customize alerts for key account activity, and stay informed by email.',
        NOTIFY_WHEN_ORDER_IS_MAILED: 'Notify me when an order is mailed',
        NOTIFY_WHEN_PAYMENT_FAILS: 'Notify me when a payment fails',
      },
    },
    USERS: {
      TITLE: 'Users',
      PAGE_TITLE: 'Manage Users',
      INVITE_BTN_TEXT: 'Invite User',
      NO_RESULT_TEXT: 'No Users to show.',
      LIMIT_MODAL: {
        TITLE: 'Feature Not Available',
        HEADING: 'This feature is not included in your current plan.',
        SUB_HEADING: 'Upgrade your plan to access this functionality.',
        DEFAULT_MODAL_HEADING: 'This feature is not included in your current plan.',
        DEFAULT_MODAL_SUB_HEADING: 'Upgrade your plan to access this functionality.',
        CANCEL_BUTTON: 'Cancel',
        SUBMIT_BUTTON: 'View Plans',
      },
      INVITE_USER: {
        TITLE: 'Invite User',
        EMAIL_LABEL: 'Email Address',
        CANCEL_BUTTON: 'Cancel',
        SUBMIT_BUTTON: 'Invite',
        ROLE_LABEL: 'Select Role',
      },
      EDIT_USER_ROLE: {
        TITLE: 'Change Role',
        ROLE_LABEL: 'Role',
        CANCEL_BUTTON: 'Cancel',
        SUBMIT_BUTTON: 'Save',
      },
      DELETE_USER: {
        TITLE: 'Delete User',
        HEADING: 'Are you sure you want to delete this User?',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
    },
    CONTACT_IMPORT: {
      TITLE: 'Imports',
    },
    EXPORT_LOGS: {
      TITLE: 'Exports',
    },
    WALLET: {
      TITLE: 'Manage Wallet',
      EXPORT: {
        SINGLE_EXPORT_HEADER: 'Export',
        MULTI_EXPORT_HEADER: 'Export list',
        EXPORT_TRANS: 'Are you sure you want to export these Transactions?',
        EXPORT_SINGLE_TRANS: 'Are you sure you want to export this Transaction?',
        EXPORT_MESSAGE: `You'll receive a confirmation email when the export is completed.`,
        EXPORT_BTN_TEXT: 'Export',
        SELECT_ALL_ITEMS: 'Select All',
        SELECT_VISIBLE_ITEMS: 'Select Visible',
        SELECT_NONE: 'Select None',
      },
      STRIPE: {
        ADD_PAYMENT_METHOD: 'Add Payment Method',
        METHOD_ADDED: 'Payment method added successfully',
        METHOD_FAILED: 'Failed to add payment method',
        METHOD_DELETE_SUCCESS: 'Payment method delete successfully',
        METHOD_DELETE_ERROR: 'Payment method delete failed',
        DEFAULT_CHANGE_SUCCESS: 'Default payment method changed successfully',
        DEFAULT_CHANGE_ERROR: 'Default payment method change failed',
        ADD_FUNDS: 'Add Funds',
        REMOVE_FUNDS: 'Remove Funds',
        TRANSACTIONS: 'Transactions',
        UPDATE_AUTOMATIC_FUNDING: 'Update Automatic Funding',
        UPDATE_AUTO_FUNDING: 'Update Auto Funding',
        MIN_AUTO_FUNDING: 'Min. Auto Funding:',
        UPDATE_MIN_AUTO_FUNDING: '(Update)',
        UPDATE_AUTO_FUNDING_SUCCESS: 'Automatic funding amount updated',
        ENABLE_AUTO_FUNDING: 'Enable Automatic Funding',
        DISABLE_AUTO_FUNDING: 'Disable Automatic Funding',
        FUNDS_ADDED: 'Funds Added',
        REASON_VALIDATION_MESSAGE: 'Reason should not exceed 200 characters.',
        PLEASE_ENTER_VALID_AMOUNT: 'Please enter a valid amount',
        AMOUNT_VALIDATION_ERROR: 'Amount should not exceed 6 digits',
        FUNDS_REMOVED: 'Funds Removed',
        ADD_FUNDS_SUCCESS: 'Funds have been added to your Wallet!',
        ADD_FUNDS_ERROR: 'Something went wrong while adding funds',
        ENTER_AMOUNT: 'Enter Amount',
        ENTER_AMOUNT_SUB_TEXT: 'Wallet funds are non-refundable',
        DECREASE_WALLET_BALANCE_BY: 'Decrease wallet balance by',
        INCREASE_WALLET_BALANCE_BY: 'Increase wallet balance by',
        REASON_FOR_DECREASE: 'Reason for this decrease (Optional)',
        REASON_FOR_INCREASE: 'Reason for this increase (Optional)',
        ENTER_MIN_AUTO_AMOUNT: 'Enter Minimum Auto Funding Amount',
        REMOVE_FUNDS_CONFIRM: 'Submit',
        CONFIRM: 'Confirm & Pay',
        SUBMIT: 'Submit',
        ENABLE_AUTO_FUND: 'Enable Automatic Funding for Orders',
        AUTO_FUNDING_TITLE_1: `Automatic Funding will ensure all of your orders do
        not fail due to not enough funds in your Wallet.`,
        AUTO_FUNDING_TITLE_2: `If you do not have enough Wallet funds, OLC will
        charge your credit card for the remaining amount to
        process your order. The minimum charge will be for
        $50.00.`,
        YOUR_BALANCE: 'Balance',
        DISABLED: 'Disabled',
        ENABLED: 'Enabled',
        ADD_FUNDING_VALIDATION: 'Amount should be greater than or equal to $50.',
        REMOVE_FUNDING_VALIDATION: 'Amount should be greater than $0.',
        AUTO_FUNDING_ENABLED_SUCCESS: 'Automatic funding enabled successfully',
        AUTO_FUNDING_DISABLED_SUCCESS: 'Automatic funding disabled successfully',
        YOUR_PAYMENT_METHOD: 'Your Payment Methods',
        PAYMENT_METHOD_ERROR: '*At least one payment method is required.',
        PAYMENT_METHOD_REQUIRED: 'Please add payment method first before adding the funds',
        AUTO_FUNDING: 'Automatic Funding',
        CARD_DECLINED_FOR_PAYMENT:
          'Your card was declined while processing the outstanding payment. Please try a different card.',
        CARD_ALSO_DECLINED: 'This card was also declined. Please try a different card.',
        PAYMENT_PROCESSING:
          "We're verifying your payment. This may take a moment, you'll be unblocked automatically once confirmed.",
        TRY_DIFFERENT_CARD: 'Use a different card',
        STATUS_MONITORING: 'Monitoring your account, will unblock automatically',
        STATUS_CHECKING: 'Checking your account status…',
        STATUS_EXHAUSTED: 'Auto-check timed out. Click to check manually.',
        STATUS_EXHAUSTED_HEADING: "You're all set, we're waiting on payment confirmation",
        STATUS_EXHAUSTED_BODY:
          "Your card has been updated. Payment confirmation can take a little while. Your access will be restored automatically once confirmed, you don't need to stay on this page.",
        RECHECK: 'Check Now',
        CLOSE_FOR_NOW: 'Close for now',
        TRANSACTION_FAILED: 'Subscription Payment Failed',
        TRANSACTION_FAILED_MESSAGE:
          'We could not charge your card for your subscription renewal, so access to your account is temporarily limited.',
        TRANSACTION_FAILED_MESSAGE_DETAIL:
          'Update your default payment method below or add a new card. We will retry the outstanding charge automatically. Full access is restored as soon as payment succeeds.',
        TRANSACTION_FAILED_WARNING_ALT: 'warning',
        SUBSCRIPTION_CANCELED: 'Your subscription has been canceled',
        SUBSCRIPTION_CANCELED_MESSAGE:
          'We were unable to collect payment after several attempts. Your data is safe and preserved. To restore full access, please start a new subscription.',
        SUBSCRIPTION_CANCELED_ICON_ALT: 'subscription canceled',
        RESUBSCRIBE: 'Re-subscribe',
        PAYMENT_METHOD_FORM_ERROR:
          'Unable to load the payment form. Please try again or refresh the page.',
        TRY_AGAIN: 'Try Again',
        LOGOUT: 'Logout',
        LOGOUT_ALT: 'logout',
        // CONFIRM: "Confirm",
        CANCEL: 'Cancel',
        DELETE_CONFIRMATION: 'Are you sure you want to delete',
        NO_TRANSACTION: ' No Transactions to show.',
        UNAUTHORIZED_ADD_FUND:
          'Only the Admins on your account are authorized to add funds to the wallet',
        UNAUTHORIZED_ADD_PAYMENT_METHOD:
          'Only the Admins on your account are authorized to add payment methods',
        UNAUTHORIZED_DELETE_PAYMENT_METHOD:
          'Only the Admins on your account are authorized to delete payment methods',
      },
    },
    PLANS: {
      AVAILABLE_PLANS_HEADING: 'Available Plans',
      PRODUCT_PRICING_HEADING: 'Product Pricing',
      HEADER: {
        HEADING:
          'You can change your billing frequency below, or change plans by selecting the button below your desired plan ',
        FREE_MONTHS: '2 MONTHS FREE',
      },
      UPGRADE: {
        TITLE: 'Upgrade Subscription',
        SUBMIT_BUTTON: 'Confirm',
        CANCEL_BUTTON: 'Cancel',
        SUCCESS: 'Your plan has been upgraded successfully.',
        CARD_DECLINED: 'Your card was declined. Please add a valid payment method and try again.',
        REQUIRES_AUTHENTICATION: 'Additional authentication is required to complete your payment.',
        GENERIC_ERROR: 'Unable to upgrade your plan. Please try again or contact support.',
      },
      DOWNGRADE: {
        TITLE: 'Downgrade Subscription',
        HEADING: 'By downgrading your account, you will lose the following features: ',
        NOTE: 'You have too many of the following to downgrade your plan. You will need to remove following before ',
        SUBMIT_BUTTON: 'Confirm',
        CANCEL_BUTTON: 'Cancel',
      },
      PLAN_CARDS: {
        LABELS: {
          USERS: 'Users',
          CONTACTS: 'Contacts',
          TEMPLATES: 'Templates',
          CUSTOM_FIELDS: 'Custom Fields',
          WEBHOOKS: 'Webhooks',
          TAGS: 'Tags',
          MAILING: 'Monthly Mailings',
          TRANSIT: 'In-Transit Mail Tracking',
          ROLES_PERMISSION: 'User Roles & Permissions',
          ANALYTICS: 'Analytics Dashboard',
          MAILER: 'Specialty Mailers',
          ZAPIER: 'Zapier',
          GO_HIGH_LEVEL: 'GoHighLevel',
          HUBSPOT: 'Hubspot',
          SHOPIFY: 'Shopify',
          SDK: 'SDK',
        },
        CURRENT_PLAN_BTN: 'Current Plan',
        UPGRADE_PLAN_BTN: 'Upgrade',
        DOWNGRADE_PLAN_BTN: 'Downgrade',
      },
      INVOICE: {
        HEADING: 'Invoices',
        NO_RESULT_TEXT: 'No Invoice to show',
        NEXT_BUTTON: 'Next',
        PREVIOUS_BUTTON: 'Previous',
      },
    },
    CANCEL_BUTTON: 'Cancel',
    SUBMIT_BUTTON: 'Change',
  },
  SETTINGS: {
    API_KEYS: {
      TITLE: 'API Keys',
      NO_API_KEYS: 'No API Keys to show.',
      COPY_KEY: 'Key copied successfully.',
      NO_EXPIRY: 'No Expiration',
      CREATE_BUTTON_TEXT: 'Create',
      RESPONSE_ALREADY_EXIST: 'API Key already exists with same name.',
      SOURCE_ALREADY_EXIST_IN_DB: 'API Key already exists with same source.',
      NAME_ALREADY_EXIST: 'API Key already exists with same name',
      INVALID_GHL_API_KEY: 'Invalid GoHighLevel API Key',
      SOURCE_ALREADY_EXIST: 'API Key already exists with same source',
      GHL_API_KEY_INVALID: 'Invalid GoHighLevel API Key',
      SOURCE_REQUIRED: 'API Key already exists with same source.',
      CREATE: {
        TITLE: 'Create API Key',
        NAME_LABEL: 'Name',
        GHL_API_KEY_LABEL: 'GHL API Key (Optional)',
        GHL_API_KEY_TOOLTIP:
          'Add your GHL API Key to enable USPS tracking webhooks for your contacts.',
        SOURCE_LABEL: 'Source',
        SOURCE_REQUIRED: 'Source is required',
        DATE_LABEL: 'Expiry Date (Optional)',
        DATE_PLACEHOLDER: 'Expiry Date',
        NAME_REQUIRED: 'Name is required',
        NAME_LESS_255: 'Name must be less than 255 characters',
        SHOPIFY_STORE_NAME_LABEL: 'Shopify Store Name*',
        SHOPIFY_STORE_NAME_REQUIRED: 'Shopify Store Name is required',
      },
      EDIT: {
        TITLE: 'Edit API Key',
      },
      DELETE: {
        TITLE: 'Delete API Key',
        HEADING: 'Are you sure you want to Delete this API Key?',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
      ROTATE: {
        TITLE: 'Rotate API Key',
        DATE_LABEL: 'Expiry Date (Optional)',
        DATE_PLACEHOLDER: 'Expiry Date',
      },
      NOT_ALLOWED: 'You are not allowed to access API Keys. Please upgrade your subscription plan.',
      CANCEL_BUTTON: 'Cancel',
      SUBMIT_BUTTON: 'Save',
    },
    GENERAL_SETTINGS: {
      TITLE: 'General Settings',
      EDIT_BTN_TEXT: 'Edit',
      ADDRESS_STRICT_LABEL: 'Address Strictness',
      ADDRESS_STRICT_DESCRIPTION:
        'Controls how strictly addresses must be validated before mail is sent.',
      RETURN_ADDRESS_NAME_LABEL: 'Return Address Configuration',
      RETURN_ADDRESS_DESCRIPTION: 'Choose which fields to include in your return address.',
      MERGE_STRICT_LABEL: 'Merge Variable Strictness',
      PROPERTY_STRICT_LABEL: 'Property Address Information',
      PROPERTY_ADDRESS_LINKING: 'Property Address Information',
      PROPERTY_ADDRESS_LINKING_DESCRIPTION:
        'Enables you to import mailing and property address information. If you’re sending mail to property owners (such as in real estate), please enable this option.',
      STRICT_LABEL: 'Strict',
      NORMAL_LABEL: 'Normal',
      RA_NAME_LABEL: 'First Name',
      RA_LAST_NAME_LABEL: 'Last Name',
      RA_COMPANY_LABEL: 'Company Name',
      RA_ADDRESS_LABEL: 'Full Address',
      RA_ERROR_MESSAGE:
        'If any field in Return Address Configuration is selected, Either First Name or Company Name must also be selected.',
      PROPERTY_INCLUDE_LABEL: 'Include',
      PROPERTY_EXCLUDE_LABEL: 'Exclude',
      RATE_LABEL: 'Rate Limits',
      PRODUCT_LABEL: 'Product:',
      PRODUCT_VALUE_1: 'Print & Mail',
      PRODUCT_VALUE_2: 'Address Verification',
      LEARN_TITLE: 'Learn More',
      CANCEL_BUTTON: 'Cancel',
      SUBMIT_BUTTON: 'Save',
    },
    TAGS: {
      TITLE: 'Tags',
      TAGS_REQUIRED: 'Please add tags before submitting!',
      NO_TAGS_RECORDS:
        'Tags let you label and organize your contacts with keywords so you can filter, search, and manage them more easily.',
      NO_TAGS: 'No Tags to show',
      CREATE_BUTTON_TEXT: 'Add New',
      CREATE: {
        TITLE: 'Create Tags',
        TAG_LABEL: 'Tags',
        TAG_PLACEHOLDER: 'Type to create a tag. Use a comma to separate tags.',
        TAG_LIMIT: 'Tag name should be less than 35 letters',
        SUBMIT_BUTTON: 'Create',
      },
      EDIT: {
        TITLE: 'Edit Tag',
        TAG_LABEL: 'Tags',
        TAG_PLACEHOLDER: 'Type to update a tag',
        TAG_REQUIRED: 'Tag name required',
        TAG_LIMIT: 'Tag name should be less than 35 letters',
        SUBMIT_BUTTON: 'Save',
      },
      DELETE: {
        TITLE: 'Delete Tag',
        HEADING: 'Are you sure you want to delete this Tag?',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
      CANCEL_BUTTON: 'Cancel',
      SUBMIT_BUTTON: 'Save',
    },
    WEBHOOKS: {
      TITLE: 'Webhooks',
      CREATE_BUTTON_TEXT: 'Create',
      NO_RESULT_TEXT: 'No Webhooks to show.',
      NO_WEBHOOK_LOGS_TEXT: 'No Webhooks Logs to show.',
      LOGS: {
        TITLE: 'Webhook Log',
        DATE_LABEL: 'Date',
        NO_RESULT_TEXT: 'No Webhooks Logs to show.',
        BACK_BUTTON: 'Back to Webhook Details',
        EVENT_TITLE: 'Event:',
        STATUS_TITLE: 'Status Code:',
        DATE_TITLE: 'Date:',
        REQUEST_TITLE: 'Request Body',
        RESPONSE_TITLE: 'Response Body',
      },
      CREATE: {
        TITLE: 'Create Webhook',
        EDIT_TITLE: 'Edit Webhook',
        URL_LABEL: 'URL',
        DESCRIPTION_LABEL: 'Description',
        SLACK_WEBHOOK_URL: 'Slack Incoming Webhook URL (For Failure Notifications)',
        SLACK_WEBHOOK_URL_VALIDATION: 'Please enter a valid Slack Webhook URL',
        CUSTOM_HEADERS_LABEL: 'Custom Headers',
        HEADERS_INFO: 'Enter custom headers as a JSON object or as key:value pairs separated by |.',
        CUSTOM_HEADERS_PLACEHOLDER: 'Enter Custom Header',
        EVENT_TYPE_LABEL: 'Event Types',
        EVENT_SAMPLE_PAYLOAD: 'Sample Payloads for Selected Event Types',
        EVENT_PLACEHOLDER: 'Select Event Types',
        EVENTS_VALIDATION: 'Please select at least one event',
        ADDITIONAL_FIELDS_LABEL: 'Additional Fields',
        ADDITIONAL_FIELDS_PLACEHOLDER: 'Select Additional Fields',
        ADDITIONAL_FIELD_FIRST_NAME: 'First Name',
        ADDITIONAL_FIELD_LAST_NAME: 'Last Name',
        ADDITIONAL_FIELD_COMPANY_NAME: 'Company',
        REQUSET_PAYLOAD_LABEL: 'Example Request Payload',
        URL_PLACEHOLDER: 'Enter URL',
        URL_REQUIRED: 'URL is required',
        URL_MAX_LENGTH: 'URL must be less than 255 characters',
        URL_INVALID: 'Please add a valid URL',
        CUSTOM_HEADERS_LENGTH: 'Custom Headers must be less than 255 characters',
        CUSTOM_HEADERS_KEY_VALUE_PAIR:
          "Custom Headers must be a JSON object or use the 'key:value | key:value' format",
        DESCRIPTION_REQUIRED: 'Description is required',
        DESCRIPTION_PLACEHOLDER: 'Enter Description',
        DESCRIPTION_MAX_LENGTH: 'Description must be less than 255 characters',
        CANCEL_BUTTON: 'Cancel',
        SUBMIT_BUTTON: 'Save',
      },
      DELETE: {
        TITLE: 'Delete Webhook',
        HEADING: 'Are you sure you want to Delete this Webhook?',
        DESCRIPTION: 'This Webhook will be deleted from your Webhooks list.',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
      STATUS: {
        ENABLE_TITLE: 'Enable Webhook',
        DISABLE_TITLE: 'Disable Webhook',
        ENABLE_HEADING: 'Are you sure you want to enable this Webhook?',
        DISABLE_HEADING: 'Are you sure you want to disable this Webhook?',
        ENABLE_DESCRIPTION: 'This Webhook will be enabled from your Webhooks list.',
        DISABLE_DESCRIPTION: 'This Webhook will be disabled from your Webhooks list.',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
      DETAILS: {
        TITLE: 'Webhook Details',
        BACK_BUTTON: 'Back to Webhooks',
        URL_LABEL: 'URL: ',
        DESCRIPTION_LABEL: 'Description: ',
        SLACK_INCOMING_WEBHOOK: 'Slack Incoming Webhook: ',
        STATUS_LABEL: 'Status: ',
        SECRET_KEY_LABEL: 'Secret Key: ',
        CUSTOM_HEADERS_LABEL: 'Custom Headers: ',
        EVENT_TYPES_LABEL: 'Event Types: ',
        ADDITIONAL_FIELDS_LABEL: 'Additional Fields: ',
        CREATED_DATE_LABEL: 'Created Date: ',
        LAST_USED_DATE_LABEL: 'Last Used Date: ',
        EDIT_BTN_TEXT: 'Edit',
        DELETE_BTN_TEXT: 'Delete',
        ENABLE_LABEL: 'Enable',
        DISABLE_LABEL: 'Disable',
      },
    },
    CUSTOM_FIELDS: {
      TITLE: 'Custom Fields',
      NO_CUSTOM_FIELDS: 'No Custom fields to show',
      CREATE_CUSTOM_FIELD: 'Create Custom Field',
      RESPONSE_ALREADY_EXIST: 'Record already exists in system',
      FIELD_EXISTS: 'This field already exists',
      CREATE: 'Create',
      ADD_NEW: 'Add New',
      NAME: 'Name',
      PLACEHOLDER: 'Enter Custom Field Name',
      NO_RECORDS_TITLE: 'No Custom Fields Yet',
      NO_RECORDS_MESSAGE:
        'Custom fields let you capture extra details on your records. Add your first custom field to stay better organized.',
      DELETE: {
        DELETE_CUSTOM_FIELDS: 'Delete Custom Field',
        ARE_YOU_SURE: 'Are you sure you want to delete this Custom Field?',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
      EDIT: {
        TITLE: 'Edit Custom Field',
        NAME: 'Name',
      },
      CUSTOM_FIELD_NAME_REQUIRED: 'Custom Field name is required',
      CUSTOM_FIELD_NAME_LIMIT: 'Custom Field name must not exceed 25 characters.',
      CUSTOM_FIELD_VALIDATION: 'Only alphanumeric characters, and spaces are allowed.',
      CUSTOM_FIELD_VALUE_VALIDATION:
        'Only letters, numbers, spaces, _, ., -, +, (, and ) are allowed.',
      CUSTOM_FIELD_URL_VALIDATION: 'Please enter a valid URL.',
      TYPE: 'Type',
      TYPE_REQUIRED: 'Custom field type is required',
      TYPE_PLACEHOLDERS: {
        single_text: 'Enter any text',
        number: 'e.g. 1,234.567',
        date: 'e.g. MM/DD/YYYY',
        phone: 'e.g. (555) 123-4567',
        currency: 'e.g. $1,234.56',
        url: 'https://example.com',
        image_url: 'https://example.com/image.png',
      },
    },
    QR_CODES: {
      TITLE: 'QR Codes',
      NO_QR_CODES: 'No Custom fields to show',
      CREATE_QR_CODES: 'Create Custom Field',
      RESPONSE_ALREADY_EXIST: 'Record already exists in system',
      FIELD_EXISTS: 'This field already exists',
      CREATE: 'Create',
      ADD_NEW: 'Add New',
      NAME: 'Name',
      PLACEHOLDER: 'Enter Custom Field Name',
      NO_RECORDS_TITLE: 'No Custom Fields Yet',
      NO_RECORDS_MESSAGE:
        'Custom fields let you capture extra details on your records. Add your first custom field to stay better organized.',
      DELETE: {
        DELETE_CUSTOM_FIELDS: 'Delete Custom Field',
        ARE_YOU_SURE: 'Are you sure you want to delete this Custom Field?',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
      ADD_NEW_MODAL: {
        TITLE: 'Create New QR Code',
        NAME: 'Name',
      },
      SCAN_NOTIFICATION_UPGRADE:
        'Scan notification emails are not included in your current plan. Please upgrade your plan to access this feature.',
      EDIT: {
        TITLE: 'Edit QR Code',
        NAME: 'Name',
      },
      CUSTOM_FIELD_NAME_REQUIRED: 'Custom Field name is required',
      CUSTOM_FIELD_NAME_LIMIT: 'Custom Field name must not exceed 25 characters.',
      CUSTOM_FIELD_VALIDATION: 'Only alphanumeric characters, and spaces are allowed.',
      CUSTOM_FIELD_VALUE_VALIDATION:
        'Only letters, numbers, spaces, _, ., -, +, (, and ) are allowed.',
    },
    PURLS: {
      TITLE: 'PURLs',
      ADD_NEW: 'Add New',
      ADD_NEW_MODAL: {
        TITLE: 'Create New PURL',
      },
      EDIT: {
        TITLE: 'Edit PURL',
      },
    },
    CANCEL_BUTTON: 'Cancel',
    SUBMIT_BUTTON: 'Save',
  },
  DASHBOARD: {
    TITLE: 'Welcome to',
    HEADING: 'Open Letter Connect!',
    SUB_HEADING:
      'Revolutionize your outreach with our personalized mailing solutions. Open Letter Connect goes beyond traditional mail services, offering innovative, seamless ways to connect with your audience. Experience the future of direct mail, where efficiency meets creativity',
    UPCOMING_MAILS_LABEL: 'Upcoming Mailings',
    NO_UPCOMING_MAILS: 'No Upcoming Mailings',
    NO_CHART_DATA: 'No Historical Mailings',
  },
  COMPAIGNS: {
    ACTIONS: {
      MODAL: {
        EDIT_HEADING: 'Edit Campaign',
        DELETE_HEADING: 'Delete Campaign',
        DELETE_HEADING_STEP: 'Delete Step',
        EDIT_DESCRIPTION: 'Are you sure you want to edit this Campaign?',
        DELETE_DESCRIPTION: 'Are you sure you want to delete this Campaign?',
        DELETE_DESCRIPTION_STEP: 'Are you sure you want to delete this Step?',
        CANCEL_BUTTON_EDIT: 'Cancel',
        SUBMIT_BUTTON_EDIT: 'Save',
        CANCEL_BUTTON_DELETE: 'No',
        SUBMIT_BUTTON_DELETE: 'Yes',
      },
      TABLE: {
        DUPLICATE: 'Duplicate',
        EDIT: 'Edit',
        DELETE: 'Delete',
      },
    },
    CANCEL_CAMPAIGN_MODAL: {
      HEADING: 'Discard Changes',
      HEADING_NEW: 'Cancel Campaign',
      DESCRIPTION: 'Are you sure you want to discard your changes?',
      DESCRIPTION_NEW: 'Are you sure you want to cancel?',
      DESCRIPTION_SECONDARY: 'All unsaved changes will be lost.',
      CANCEL_BUTTON: 'No',
      SUBMIT_BUTTON: 'Yes',
    },
    DRAFT_RECOVERY: {
      CREATE: {
        TITLE: 'Unsaved Campaign Draft Found',
        DESCRIPTION: 'You have an unsaved campaign draft.',
        MESSAGE: 'Would you like to continue editing or start fresh?',
      },
      EDIT: {
        TITLE: 'Unsaved Campaign Draft Found',
        DESCRIPTION: 'Unfinished edits exist for this campaign.',
        MESSAGE: 'Would you like to continue editing or start fresh?',
      },
      AUTO_SAVE_INDICATOR: 'Auto-saving...',
      STORAGE_WARNING: 'Storage space is running low. Consider cleaning up old drafts.',
      STORAGE_ERROR: 'Unable to save draft due to storage limitations.',
    },
    NO_CAMPAIGNS_SCREEN: {
      TITLE: 'You have no Campaigns in your database',
      TITLE_NEW: 'No Campaigns Yet',
      MESSAGE:
        'Campaigns let you send multi-touch mailers using one or more templates. Set them up to stay consistent, automate follow-ups, and track results over time.',
      LEARN_MORE_BUTTON: 'Learn more',
      CREATE_BUTTON_NEW: 'Create Campaign',
      CREATE_CAMPAIGN_BUTTON: 'Create Your First Campaign',
    },
    SEARCH_PLACE_HOLDER: 'Search by campaign name',
    CREATE_CAMPAIGN_BUTTON: 'Create',
  },
  ADMIN_DASHBOARD: {
    OVERVIEW: {},
    USERS: {
      SEARCH_PLACE_HOLDER: 'Search by user ID, company name, user name or email',
      CLEAR_FILTER_BTN_TEXT: 'Clear Filters',
      NO_RESULT_TEXT: 'No results with current filters.',
      NO_USERS_SCREEN: {
        TITLE: 'You have no Users in your database',
      },
      ADVANCE_FILTERS: {
        HEADING: 'Filters',
        COMPANY_LABEL: 'Company',
        COMPANY_PLACEHOLDER: 'Select Company',
        NO_COMPANY: 'No Company to show',
        ROLE_LABEL: 'Role',
        ROLE_PLACEHOLDER: 'Select Role',
        NO_ROLE: 'No Role to show',
        PLAN_LABEL: 'Plan',
        PLAN_PLACEHOLDER: 'Select Plan',
        NO_PLAN: 'No Plan to show',
        SIGN_UP_DATE_LABEL: 'Sign Up Date',
        DATE_PLACEHOLDER: 'Select Date',
        SYSTEM_ADMIN_LABEL: 'Show System Admins Only',
        CANCEL_BUTTON: 'Clear',
        SUBMIT_BUTTON: 'Apply',
      },
      IMPERSONATION: {
        HEADER: {
          TITLE: 'You are logged in as ',
          SUB_HEADING: 'Switch back to Admin',
        },
        IMPERSONATE_MODAL: {
          HEADING: 'Are you sure you want to impersonate',
          CANCEL_BUTTON: 'No',
          SUBMIT_BUTTON: 'Yes',
        },
        SWITCH_BACK_MODAL: {
          HEADING: 'Are you sure you want to switch back to the Admin Portal?',
          CANCEL_BUTTON: 'No',
          SUBMIT_BUTTON: 'Yes',
        },
      },
      USER_ACTION: {
        ENABLE_TITLE: 'Enable User',
        DISABLE_TITLE: 'Disable User',
        ENABLE_HEADING: 'Are you sure you want to enable this User?',
        DISABLE_HEADING: 'Are you sure you want to disable this User?',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
      EXPORT: {
        EXPORT_BTN_TEXT: 'Export',
        SINGLE_EXPORT_HEADER: 'Export',
        MULTI_EXPORT_HEADER: 'Export list',
        EXPORT_USERS: 'Are you sure you want to export these Users?',
        EXPORT_SINGLE_USERS: 'Are you sure you want to export this User?',
        EXPORT_MESSAGE: `You'll receive a confirmation email when the export is completed.`,
      },
      SELECT_ALL_ITEMS: 'Select All',
      SELECT_VISIBLE_ITEMS: 'Select Visible',
      SELECT_NONE: 'Select None',
      USER_ACTIONS: {
        IMPERSONATE: 'Impersonate',
        ADD_FUNDS: 'Add Funds',
        REMOVE_FUNDS: 'Remove Funds',
        VIEW_TRANSACTIONS: 'View Transactions',
        ENABLE_ACCOUNT: 'Enable Account',
        DISABLE_ACCOUNT: 'Disable Account',
      },
    },
    ORDERS: {
      CLEAR_FILTER_BTN_TEXT: 'Clear Filters',
      NO_RESULT_TEXT: 'No results with current filters.',
      ADVANCE_FILTERS: {
        HEADING: 'Filters',
        CREATED_BY_LABEL: 'Created By',
        CREATED_BY_PLACEHOLDER: 'Search by user name/email',
        NO_CREATED_BY: 'No Created By to show',
        PRODUCT_TYPE_LABEL: 'Product type',
        PRODUCT_TYPE_PLACEHOLDER: 'Select Product Type',
        NO_PRODUCT_TYPE: 'No Product Type to show',
        SOURCE_LABEL: 'Source',
        SOURCE_PLACEHOLDER: 'Select Source',
        NO_SOURCE: 'No Source to show',
        ORDER_STATUS_LABEL: 'Order Status',
        ORDER_STATUS_PLACEHOLDER: 'Select Order Status',
        NO_ORDER_STATUS: 'No Order Status to show',
        PAYMENT_STATUS_LABEL: 'Payment Status',
        PAYMENT_STATUS_PLACEHOLDER: 'Select Payment Status',
        NO_PAYMENT_STATUS: 'No Payment Status to show',
        CREATED_DATE_LABEL: 'Created Date',
        SCHEDULED_DATE_LABEL: 'Scheduled Date',
        MAILING_DATE_LABEL: 'Mailing Date',
        MAILED_DATE_LABEL: 'Mailed Date',
        DATE_PLACEHOLDER: 'Select Date',
        CANCEL_BUTTON: 'Clear',
        SUBMIT_BUTTON: 'Apply',
      },
      CANCEL_ORDER_MODAL: {
        HEADING: 'Confirm Cancel Order?',
        TITLE: 'Are you sure you want to cancel this Order?',
        CANCEL_BUTTON: 'Go Back',
        SUBMIT_BUTTON: 'Cancel Order',
      },
      DISPATCH_ACTION: {
        TITLE: 'Dispatch Order',
        HEADING: 'Are you sure you want to dispatch this order now?',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
        DISPATCH_DATE_LABEL: 'Mail Date',
      },
      RESCHEDULE_ACTION: {
        TITLE: 'Reschedule Order',
        HEADING: 'Select a new date to reschedule the order.',
        RESCHEDULE_DATE_LABEL: 'Reschedule Date',
        RESCHEDULE_DATE_LABEL_NEW: 'Select New Mail Date',
        RESCHEDULE_DATE_PLACEHOLDER: 'Mail Date',
        CANCEL_BUTTON: 'Cancel',
        SUBMIT_BUTTON: 'Reschedule',
        DATE_REQUIRED: 'Please select the reschedule date.',
      },
      EXPORT: {
        EXPORT_BTN_TEXT: 'Export',
        SINGLE_EXPORT_HEADER: 'Export',
        MULTI_EXPORT_HEADER: 'Export list',
        EXPORT_ORDERS: 'Are you sure you want to export these Orders?',
        EXPORT_SINGLE_ORDER: 'Are you sure you want to export this Order?',
        EXPORT_MESSAGE: `You'll receive a confirmation email when the export is completed.`,
      },
    },
    BATCHES: {
      SEARCH_PLACE_HOLDER: 'Search by batch ID',
      CLEAR_FILTER_BTN_TEXT: 'Clear Filters',
      NO_RESULT_TEXT: 'No results with current filters.',
      NO_BATCHES_SCREEN: {
        TITLE: 'You have no Batches in your database',
      },
      BATCH_LINK_HEADER: 'Accutrace Link(s) for Batch ID: ',
      ADVANCE_FILTERS: {
        HEADING: 'Filters',
        ACCUZIP_STATUS_LABEL: 'Accuzip Status',
        ACCUZIP_STATUS_PLACEHOLDER: 'Select Accuzip Status',
        NO_ACCUZIP_STATUS: 'No Accuzip Status to show',
        PRODUCT_TYPE_LABEL: 'Product type',
        PRODUCT_TYPE_PLACEHOLDER: 'Select Product Type',
        NO_PRODUCT_TYPE: 'No Product Type to show',
        SOURCE_LABEL: 'Source',
        SOURCE_PLACEHOLDER: 'Select Source',
        BATCH_STATUS_LABEL: 'Batch Status',
        BATCH_STATUS_PLACEHOLDER: 'Select Batch Status',
        NO_BATCH_STATUS: 'No Batch Status to show',
        CREATED_DATE_LABEL: 'Created Date',
        SCHEDULED_DATE_LABEL: 'Scheduled Date',
        DATE_PLACEHOLDER: 'Select Date',
        CANCEL_BUTTON: 'Clear',
        SUBMIT_BUTTON: 'Apply',
      },
      REGENERATE_PDF: {
        TITLE: 'PDF Generation',
        HEADING: 'Are you sure you want to regenerate PDF for this batch?',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
      DOWNLOAD_CSV: 'Download CSV',
      DOWNLOAD_PDF: 'Download PDF',
      PDF_GENERATION_NOT_SUPPORTED: 'PDF is not available for Real Penned products.',
    },
    CATEGORIES: {
      TITLE: 'Template Category',
      CREATE_BTN_TEXT: 'Create',
      SORT_BTN_TEXT: 'Re-Arrange',
      NO_TEMPLATE_CATEGORY: 'No Template Category to show',
      CATEGORY_UPDATED: 'Templates association updated successfully',
      NO_CATEGORIES_SCREEN: {
        TITLE: 'You have no Categories in your database',
        CREATE_CATEGORY_BUTTON: 'Create New Category',
      },
      CREATE: {
        TITLE: 'Create Template Category',
        NAME_LABEL: 'Name',
        NAME_PLACEHOLDER: 'Template Category',
        CATEGORY_NAME_REQUIRED: 'Category name is required',
        CATEGORY_NAME_LIMIT: 'Category name should be less than 255 letters',
        DESCRIPTION_LABEL: 'Description',
        DESCRIPTION_PLACEHOLDER: 'Template Category Description',
        CATEGORY_DESC_LIMIT: 'Category description should be less than 255 letters',
      },
      REARRANGE: {
        TITLE: 'Re-Arrange Categories',
        CANCEL_BUTTON: 'Cancel',
        SUBMIT_BUTTON: 'Update',
      },
      DELETE: {
        TITLE: 'Delete Category',
        HEADING: 'Are you sure you want to Delete this Template Category?',
        CANCEL_BUTTON: 'No',
        SUBMIT_BUTTON: 'Yes',
      },
      EDIT: {
        TITLE: 'Edit Template Category',
        NAME_LABEL: 'Name',
        NAME_PLACEHOLDER: 'Type to update a Template Category',
      },
      ASSIGN_TEMPLATE: {
        TITLE: 'Associate Templates',
        TEMPLATES_LABEL: 'Templates',
        TEMPLATES_PLACEHOLDER: 'Select Templates',
        SUCCESS_MESSAGE: 'Template association has been updated successfully.',
        MULTI_SUCCESS_MESSAGE: 'Template associations have been updated successfully.',
        DISASSOCIATE_MESSAGE: 'All templates have been disassociated.',
        SUBMIT_BUTTON: 'Update',
      },
      CANCEL_BUTTON: 'Cancel',
      SUBMIT_BUTTON: 'Save',
    },
    LOOKUPS: {
      SEARCH_PLACE_HOLDER: 'Search by barcode',
      CLEAR_FILTER_BTN_TEXT: 'Clear Filters',
      ADVANCE_FILTERS: {
        HEADING: 'Filters',
        ORDER_ID_LABEL: 'Order ID',
        ORDER_ID_PLACEHOLDER: 'Enter Order ID',
        ORDER_ITEM_ID_LABEL: 'Order Item ID',
        ORDER_ITEM_ID_PLACEHOLDER: 'Enter Order Item ID',
        BATCH_ID_LABEL: 'Batch ID',
        BATCH_ID_PLACEHOLDER: 'Enter Batch ID',
        MAILED_DATE_LABEL: 'Mailed Date',
        DATE_PLACEHOLDER: 'Select Date',
        CANCEL_BUTTON: 'Clear',
        SUBMIT_BUTTON: 'Apply',
      },
    },
    QUERIES: {
      TITLE: 'Template Designer Queries',
      CREATE_BTN_TEXT: 'Create',
      NO_TEMPLATE_QUERY: 'No Designer Query to show',
      TEMPLATE_PUBLISHED: 'Template published successfully',
      TEMPLATE_SUBMITTED_FOR_APPROVAL: 'Template sent for approval successfully',
      FILE_DOWNLOADED: 'File downloaded successfully',
      FILE_DOWNLOAD_FAILED: 'Error downloading file',
      URL_NOT_FOUND: 'File URL is missing',
      SEARCH_PLACE_HOLDER: 'Search by template name, ID or email',
      PUBLISHED_TEMPLATE_ID: 'Published Template ID: ',
      PROFESSIONAL_WINDOWED: 'Windowed',
      PROFESSIONAL_NON_WINDOWED: 'Non-Windowed',
    },
  },
  SNACKBAR: {
    HEADING: 'Notification',
    SUCCESS_TITLE: 'Success',
    UNSUCCESSFUL_TITLE: 'Unsuccessful',
  },
  MODE_REMINDER: {
    TITLE: 'Your account is currently in Test Mode. Some features may be limited.',
    LINK_MESSAGE: 'Mode Switching Guide',
  },
  REQUEST: {
    SUBSCRIPTION_PLAN_DENIED: {
      TITLE: 'Access Limited',
      SUBHEADING:
        'Bulk Export is a feature reserved for our premium plans. Upgrade your subscription today to enjoy this and other advanced features!',
      MESSAGE: ' ',
    },
  },
  PHONE_TRACKING: {
    ACTIVATE_MODAL: {
      PHONE_NAME_TOOLTIP:
        'A name to help you identify this tracking number (ex: "Probate Campaign")',
      CALL_FORWARDING_TOOLTIP:
        'The phone number where incoming calls from this tracking number will be forwarded.',
      SMS_EMAIL_TOOLTIP:
        'The email address that will receive any text messages sent to this tracking number.',
    },
  },
  INTEGRATIONS: {
    YOUR_INTEGRATIONS_LABLE: 'Your Integrations',
    SUGGESTED_INTEGRATIONS_LABLE: 'Suggested Integrations',
    CARD: {
      READ_LABEL: 'Read Documentation',
      DISABLE_BUTTON_LABEL: 'Disable',
      ENABLE_BUTTON_LABEL: 'Enable',
    },
    MODAL: {
      ENABLE_LABEL: 'Enable',
      DISABLE_LABEL: 'Disable',
      ENABLE_HEADING: 'Are you sure you want to enable',
      DISABLE_HEADING: 'Are you sure you want to disable',
    },
  },
};

export const getNoResultsMessage = ({ searchApplied = false, filterSize = 0 } = {}) =>
  searchApplied || Number(filterSize) === 0
    ? MESSAGES.NO_RESULTS_SEARCH_TEXT
    : MESSAGES.NO_RESULTS_FILTERS_TEXT;
